import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddAlarmIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add_alarm"}/>
}
